import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import MuiCheckbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

type Props = {
  label: string
  name: string
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
  value: string
}

export function ServiceCheckbox(props: Props) {
  const { label, name, onChange, value } = props

  const theme = useTheme()

  return (
    <FormControlLabel
      label={label}
      control={<MuiCheckbox />}
      sx={{ margin: 0, padding: theme.spacing(0.8) }}
      value={value}
      name={name}
      onChange={onChange}
    />
  )
}
